/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const reservePrepaymentRequestSchema = z
	.object({
		amount: z
			.string()
			.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
			.optional(),
		email: z.email().optional(),
	})
	.describe("Предоплата банкета: сумму можно не передавать — тогда платится остаток.");
